<template>
    <div>
  <aside v-bind:class="{'PC-sidebarTop': position == 'top'}">
    <div class="contenidoAside container container--estandar">
      <form @submit.prevent="" v-if="isOpen || position != 'top'">
        <p class="title" v-if="position != 'top'">{{$t('language.posadasCorporate.busquedaAvanzada.buscarTarifas')}}</p>
        <div class="row">
          <div class="col-12 col-lg-4">
            <p class="titleBuscador">{{$t('language.posadasCorporate.busquedaAvanzada.consultaNumeroConfirmación')}}:</p>
            <div class="form-element w-100">
              <label>{{$t('language.posadasCorporate.busquedaAvanzada.numeroConfirmacion')}}</label>
              <div class="contenidoSearch">
                <i class="search-icons" :class="busquedaAvanzada ? 'icon-search' : 'icon-close pointer'" @click="busquedaAvanzada ? '' : [confirmacion = '', busquedaAvanzada = true]"></i>
                <input class="mb-2" type="number" :value="confirmacion" @input="updateValue" @click="busquedaAvanzada = false" disabled>
              </div>
            </div>
          </div>

          <div class="col-12 col-lg-8">
            <p class="titleBuscador">{{$t('language.posadasCorporate.busquedaAvanzada.numeroConfirmacion')}}:</p>
            <div class="form-element seguimiento">
              <label>{{$t('language.posadasCorporate.busquedaAvanzada.hotel')}}</label>
              <div class="contenidoSearch" @click="[buscador = true]" v-click-outside="outsideSearch">
                <i class="search-icons icon-search" v-if="!buscador"></i>
                <i class="search-icons icon-close pointer" v-if="buscador" @click="search = ''"></i>
                <input class="elipse" type="text" :placeholder="$t('language.posadasCorporate.busquedaAvanzada.buscar')"  v-model="search" v-b-popover.hover.top="{ content: search, customClass:'PC-popover' }">
              </div>
<div class="card buscadorCard vb" v-if="buscador" v-bar>
                <div>
                  <div class="buscador" v-for="hotel in filteredList" :key="hotel.id">
                    <p class="mb-1 nombre" @click="[cambiaValue(hotel.nombre, hotel.adults), buscador = 0]" v-html="$options.filters.resalt( hotel.nombre , search)"></p>
                  </div>

                </div>
              </div>
            </div>

            <!-- Fechas -->
            <div class="form-element seguimiento">
              <label>{{$t('language.posadasCorporate.busquedaAvanzada.fechas')}}</label>
              <div class="d-block">
             
             <div>
                <div class="entradaInput position-relative d-inline-block w-50">
                  <i class="calendarIcon demo-icon icon-calendar position-absolute" v-if="entrada.length < 1"></i>
                  <i class="calendarIcon limpiarCalendario demo-icon icon-close position-absolute" v-else @click="[entrada = '',salida = '']"></i>
                  <datepicker class="w-100 fechaEntrada" v-model="entrada" lang="es"
                    :clearable="false" :placeholder="$t('language.posadasCorporate.busquedaAvanzada.entrada')" format="DD/MM/YYYY"
                     :disabled="search.length < 1" v-if="tryingAgain == 'es'"></datepicker>
                     <datepicker class="w-100 fechaEntrada" v-model="entrada" lang="en"
                    :clearable="false" :placeholder="$t('language.posadasCorporate.busquedaAvanzada.entrada')" format="MM/DD/YYYY"
                     :disabled="search.length < 1" v-if="tryingAgain == 'en'"></datepicker>
                </div>
                <div class="entradaInput position-relative d-inline-block w-50">
                  <i class="calendarIcon demo-icon icon-calendar position-absolute" v-if="salida.length < 1"></i>
                  <i class="calendarIcon limpiarCalendario demo-icon icon-close position-absolute" v-else @click="salida = ''"></i>
                  <datepicker class="w-100 fechaSalida" v-model="salida" lang="es" :clearable="false"
                  :placeholder="$t('language.posadasCorporate.busquedaAvanzada.salida')" format="DD/MM/YYYY" :not-before="entrada"
                  :disabled-days="[entrada]" :disabled="!entrada" v-if="tryingAgain == 'es'"></datepicker>
 <datepicker class="w-100 fechaSalida" v-model="salida" lang="en" :clearable="false"
                  :placeholder="$t('language.posadasCorporate.busquedaAvanzada.salida')" format="MM/DD/YYYY" :not-before="entrada"
                  :disabled-days="[entrada]" :disabled="!entrada" v-if="tryingAgain == 'en'"></datepicker>

                </div>
                  
                
              </div>
           
             
              </div>
            </div>

          </div>

        </div>
                                    <Loader v-if="enableLoader"/>

        <div class="form-element" v-bind:class="[position=='top'?'mt-3 m-b-0':'mt-5']">
          <button class="consultar" @click="perdreToi" :disabled="pourHotel && pourEntre && pourSortir">{{$t('language.posadasCorporate.busquedaAvanzada.consultar')}}</button>
        </div>
      </form>
      <div class="text-left" v-if="!isOpen && position == 'top'">
        <ul class="SidebarTop-info">
          <li
          v-show="!(
          searchDataAvanzada.hotel ||
          searchDataAvanzada.fechas.checkin)">
            {{$t('language.posadasCorporate.busquedaAvanzada.buscarTarifas')}}
          </li>
          <li v-show="!searchDataAvanzada.confirmacion">
            <span class="icon-doc-detail"></span>
            <span>------------------</span>
          </li>
          <li v-show="searchDataAvanzada.hotel">
            <span class="icon-building"></span>
            <span>{{search}}</span>
          </li>
          <li v-show="searchDataAvanzada.fechas.checkin">
            <span class="icon-calendar"></span>
            <span>
              {{searchDataAvanzada.fechas.checkin.toLocaleDateString()}}
              -
              {{searchDataAvanzada.fechas.checkout.toLocaleDateString()}}
            </span>
          </li>
        </ul>
      </div>
      <button
      class="SidebarTop-toggleButton"
      v-bind:class="{'SidebarTop-toggleButton--open':isOpen}"
      @click="isOpen ? isOpen = false : isOpen = true; hellow();">
        <span
        v-bind:class="[isOpen?'icon-up':'icon-navigate-down']"
        class="icon-navigate-down">
        </span>
      </button>    
    </div>

    <!-- Panel mobile Fechas NO BORRAR Se utiliza funcion para sima de días -->
    <div class="oculto" >
      <datepicker class="salida" v-model="salida" lang="es" :clearable="false"
            placeholder="Salida" format="DD/MM/YYYY" :not-before="entrada"
            :disabled-days="[entrada]" :disabled="[!entrada, !cambiarFechaSalida]"></datepicker>
    </div>
  </aside>

<!--ByDates is broken -->
 <modal v-show="isModalVisibleByDates" @close="closeModalByDates" maxWidth="max-w-500">
      <template slot="header">
        <b class="caution"> <i class="demo-icon icon-warning-fill Fw-bolder"></i>{{ $t('language.posadasCorporate.modales.withoutChances.title') }}</b>
      </template>
      <template slot="body">
        <p class="Ta-left">
                           {{ $t('language.posadasCorporate.modales.withoutChances.body') }}

        </p>
      </template>
      <template slot="footer">
       
        <button type="button" class="button btn-primary" @click="closeModalByDates"
          aria-label="Close modal">
          {{ $t('language.posadasCorporate.modales.withoutChances.button') }}
        </button>
      </template>
    </modal>
<!--ByDates is broken -->
 <!-- EXPIRED SESSION MODAL  -->
    <modal v-show="isExpiredModalVisible" @close="closeExpiredModal" maxWidth="max-w-500">
      <template slot="header">
        <b class="caution"> <i class="demo-icon icon-warning-fill Fw-bolder"></i> {{ $t('language.posadasCorporate.modales.expiredSession.title') }}</b>
      </template>
      <template slot="body">
        <p class="Ta-left">
          {{ $t('language.posadasCorporate.modales.expiredSession.body') }}
        </p>
      </template>
      <template slot="footer">

        <button type="button" class="button btn-primary" @click="closeExpiredModal"
                aria-label="Close modal">
          {{ $t('language.posadasCorporate.modales.expiredSession.button') }}
        </button>


      </template>
    </modal>
    <!-- EXPIRED SESSION MODAL  -->

  </div>
</template>

<script>
import * as GlobalFunctions from '../../utils/GlobalFunctions';
import Datepicker from 'vue2-datepicker'
import SecureLS from 'secure-ls';
import axios from 'axios';
import Loader from '../loader/Loader';
import Modal from '../addons/Modal.vue'
  import i18n from '../../plugins/i18n';

export default {
  name: 'SidebarTopAvanzada',
  components: {
    Datepicker,
    Loader,
    Modal

  },
  data() {
    return {
      ls: new SecureLS({ encodingType: "aes" }),
      codeHotelF: '',
      isExpiredModalVisible: false,
      isModalVisibleByDates: false,
      enableLoader: false,
      counter1: 0,
      counter2: 0,
      counter3: 0,
      pourHotel: true,
      pourEntre: true,
      pourSortir: true,
      hidden: 'hiddenn',
      visibility: '',
      esoculto: true,
      ocultoSetting: true,
      dialog: false,
      tabActive: 1,
      search: true,
      reservacion: true,
      busquedaAvanzada: true,
      confirmacion: '',
      hotel: '',
      max: 10,
      entrada: '',
      salida: '',
      picked: '',
      // buscador
      buscador: false,
      search: '',
      hoteles: [],
      isOpen: false,
      searchDataAvanzada: this.searchdataAvanzada || {
        confirmacion: '------------',
        hotel: '',
        fechas: { checkin: null, checkout: null },
      },
      todayDate: new Date(),
      
      
    };
  },
  props: {
    position: String,
    searchdataAvanzada: Object,
  },
  created() {
      this.enableLoader = false
      var ls = new SecureLS({encodingType: 'aes'});
var hotel1 = ls.get('S1')
var entrada = ls.get('S2')
var salida = ls.get('S3')
this.search = hotel1.data
this.entrada = entrada.data
this.salida = salida.data
  },
  methods: {
     closeExpiredModal() {
             this.isExpiredModalVisible = false
             var ls = new SecureLS({encodingType: 'aes'});
             GlobalFunctions.localStorageClean();
             this.$router.push({ name: 'Login'})
      },
    closeModalByDates() {
        this.isModalVisibleByDates = false
        this.enableLoader = false
    },
    hellow() {
      this.$store.commit('avanzada')
    },
    theSearch() {

            var ls = new SecureLS({encodingType: 'aes'});
                var  aa =  ls.get('hotelInfo'); // set key1
      var hotelInfos = aa.data.response
      var IsTheBest = []
      this.hoteles = []
    for(var i = 0; i < hotelInfos.length; i++) {
      for(var j = 0; j < hotelInfos[i].hotelInfoResponseList.length; j++) {
      IsTheBest.push({'nombre': hotelInfos[i].hotelInfoResponseList[j].hotelName, 'adults': false, 'hotelCode': hotelInfos[i].hotelInfoResponseList[j].hotelCode})
}

    }
       this.hoteles = IsTheBest
    },
     clearLocalStorage() {
        this.isExpiredModalVisible = true
               

            },
    pop() {
      this.ls.set('S1', {data: this.search})
        this.ls.set('S2', {data: this.entrada})
        this.ls.set('S3', {data: this.salida})
      var qw = new Date(this.entrada)
var qw2 = new Date(this.salida)
this.searchDataAvanzada.fechas.checkin = qw
this.searchDataAvanzada.fechas.checkout = qw2
 
           this.$store.commit('dateSlider');
  if(error.response.status == 404 && error.response.data.errorCode == 'RSP_RESERV_SEARCH_HOTEL_01') {
        //  this.noCoincidences()
        this.isModalVisibleByDates = true
        }
    },
    perdreToi() {
      this.enableLoader = true
      
      
/*Implementar llamado a servicio de consulta de búsqueda de reservaciones por nombre de hotel y fechas*/ 
 var ls = new SecureLS({encodingType: 'aes'});
          var a = ''  
       a = ls.get('Token') 
       this.token = a.data.substr(1);
       this.language = ls.get('Language'); 
       var input = this.entrada
       var output = this.salida
       function convert(input) {
  var date = new Date(input),
    mnth = ("0" + (date.getMonth() + 1)).slice(-2),
    day = ("0" + date.getDate()).slice(-2);
  return [day, mnth, date.getFullYear()].join("/");

}
var videoGames = convert(this.entrada)
var videoGames2 = convert(this.salida)
for(var i = 0; i < this.hoteles.length; i++) {
  if(this.search == this.hoteles[i].nombre) {
    this.codeHotelF = this.hoteles[i].hotelCode
  }
}
var editOrDeleteSameProfileIdReservations = ls.get('PROMOSH')
var hasEditCancelPermissions = false
if(editOrDeleteSameProfileIdReservations.data.editOrDeleteSameProfileIdReservations) {
hasEditCancelPermissions = true
} else {
hasEditCancelPermissions = false
}
  axios.post(process.env.VUE_APP_HOSTCORPORATEAPI +process.env.VUE_APP_CORPORATEAPI  + process.env.VUE_APP_DATE, {
   hotelCode: this.codeHotelF,
	startDate: videoGames,
  endDate: videoGames2,
  hasEditCancelPermissions: hasEditCancelPermissions  
  }, {
       withCredentials: true,
         credentials: 'include',
      headers: {'Authorization': 'Bearer '+ this.token,
                  'Accept-Language': this.language.data,
                  'Content-Type' : 'application/json',
                  }
         })
  .then(res => {
         var resObject=JSON.parse(JSON.stringify(res));
     if ( resObject.status == 200 || resObject.status == 201) {
            var ls = new SecureLS({ encodingType: "aes" });
             ls.set("dateReservation", { data: resObject });
      this.enableLoader = false
        this.pop()
     }
           })
      .catch(error=>{
// Error server
   let errorObject=JSON.parse(JSON.stringify(error));
 if(errorObject.message == 'Network Error' || ( error.response.status < 600 && error.response.status > 404 ) || ( error.response.status < 399 && error.response.status > 299  ) ||  error.response.status < 200   ) {
  this.$router.push({ name: "Error" });
}
// Error server
          if(error.response.status == 404 && error.response.data.errorCode == 'RSP_RESERV_SEARCH_HOTEL_01') {
            this.isModalVisibleByDates = true
          }
          this.enableLoader = false
          if (error.response.status == 401 || error.response.status == 403) {
            this.isExpiredModalVisible = true
            this.clearLocalStorage()
          }

})

    },
    // buscador
    cambiaValue(hotel, esParaAdultos) {
        return this.search = hotel;
    },
    // Cerrar inputs
    outsideSearch(e) {
      this.buscador = false;
    },
    outsideRooms(e) {
      this.rooms = true;
    },
    outsideRoom(e) {
      this.room = true;
    },

    switchHidden() {
        this.hidden = this.hidden === 'hiddenn' ? '' : 'hiddenn'
    },
    updateValue(event) {
      const value = event.target.value
      if (String(value).length <= 10) {
        this.confirmacion = value
      }
      this.$forceUpdate()
    },
  },
  watch: {
    changeHotel() {
var qw = new Date(this.changeDate)
var qw2 = new Date(this.changeDate2)
this.searchDataAvanzada.fechas.checkin = qw
this.searchDataAvanzada.fechas.checkout = qw2
     if(this.changeHotel) {

          this.search = this.changeHotel
          this.entrada = this.changeDate
          this.salida = this.changeDate2

        

        }
    },
    search() {
      this.counter1++
      if(this.counter1 > 1) {

        this.pourHotel = false
      }
    },
    entrada() { 
      this.counter2++

      if(this.counter2 > 1) {

        this.pourEntre = false
      }
    },
    salida() { 
      this.counter3++

      if(this.counter3 > 1) {

        this.pourSortir = false
      }
    },

findingWS() {
        this.theSearch()
    }
  },
  computed: {
    changeHotel() {
        return this.ls.get('S1').data
    },
    changeDate() {
        return this.ls.get('S2').data
    },
    changeDate2() {
        return this.ls.get('S3').data
    },
    findingWS() {
      return this.$store.getters.gettingAvanzada
    },
    tryingAgain() {
                return this.$store.getters.gettingLang
        },
    // buscador
    filteredList() {
      return this.hoteles.filter(hotel => {
        return hotel.nombre.toLowerCase().includes(this.search.toLowerCase())
      })
    },
    cambiarFechaSalida(){
        if( this.entrada) {
          var fechaEntrada = new Date(this.entrada),
          dias = 2

          return this.salida = fechaEntrada.setDate(fechaEntrada.getDate() + dias);
        }
      }
    
  },
  filters: {
    // buscador
    resalt: function (value,valueFromSearch) {
      if (!value) return ''
      valueFromSearch != '' ? value = value.replace(valueFromSearch, '<span class="PC-text--semibold PC-color--colorBase2">'+valueFromSearch+'</span>') : value = value;
      return value;
    }
  },
  directives: {
    'click-outside': {
      bind: function(el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== 'function') {
        	const compName = vNode.context.name
          let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`
          if (compName) { warn += `Found in component '${compName}'` }
        }
        // Define Handler and cache it on the element
        const bubble = binding.modifiers.bubble
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
          	binding.value(e)
          }
        }
        el.__vueClickOutside__ = handler

        // add Event Listeners
        document.addEventListener('click', handler)
			},
      
      unbind: function(el, binding) {
        // Remove Event Listeners
        document.removeEventListener('click', el.__vueClickOutside__)
        el.__vueClickOutside__ = null

      }
    }
  },
  
};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '../../assets/scss/config.scss';
  aside {
    width: 20%;
    position: fixed;
    margin-top: 57px;
    z-index: 2;
    height: 100%;
    padding: 32px 32px 0 47px;
  }
  @media only screen and (max-width: 1440px) {
    aside {
      width: 25%;
      padding: 32px 32px 0 47px;
    }
  }
  @media only screen and (max-width: 1100px) {
    aside {
      width: 25%;
      padding: 32px 22px 0 37px;
    }
  }
  @media only screen and (max-width: 992px) {
    aside {
      width: 100%;
      position: relative;
    }
  }
  .titleBuscador{
    font-size: $font-size-base;
    font-weight: bold;
    text-align: left;
    padding-left: 15px;
    margin-bottom: 0;
  }
  .subtitle {
    margin-bottom: 16px;
  }
  .datepicker__wrapper {
    background: none !important;
    .datepicker__dummy-wrapper {
      border: none !important;
      .datepicker__input {
        line-height: 1 !important;
        height: 16px !important;
        padding: 0 !important;
      }
      .datepicker__input:first-child {
        text-indent: 25px !important;
      }
    }
    .datepicker__clear-button {
      font-size: 25px !important;
      height: 28px !important;
      margin: 4px -2px 0px 9px !important;
      padding: 0 !important;
      position: absolute !important;
      right: 0 !important;
      top: 0 !important;
      width: 26px !important;
    }
  }
  .inputHabitacionesLeft{
    box-shadow: 0px 0px 6px 0 $colorFocus;
    border-left: solid 1px $colorFocus !important;
    border-top: solid 1px $colorFocus !important;
    border-bottom: solid 1px $colorFocus !important;
  }
  .inputHabitacionesRight{
    box-shadow: 2px 0px 6px 0 $colorFocus;
    border-right: solid 1px $colorFocus !important;
    border-top: solid 1px $colorFocus !important;
    border-bottom: solid 1px $colorFocus !important;
  }
  .inputTypeHabitacionesFocus{
    box-shadow: 0px 0px 6px 0 $colorFocus;
    border-left: solid 1px $colorFocus !important;
    border-right: solid 1px $colorFocus !important;
    border-top: solid 1px $colorFocus !important;
    border-bottom: solid 1px $colorFocus !important;
  }
  //fechas
  .salida {
    .vdp-datepicker__calendar {
      left: 0;
    }
  }
  .calendarIcon {
    margin-top: 11px;
    margin-left: 5px;
    font-size: $font-size-exlarge;
    color: $colorBase2;
    z-index: 3;
  }
  .limpiarCalendario {
    cursor: pointer;
  }
  // Tipo de habitaciones
  .typeRoom {
    .allRooms {
      border-bottom: 1px solid $colorBase5;
    }
    .opcionesRoom {
      border-top: 1px solid $colorBase5;
    }
  }
  .room {
   
    .bordecito {
      border: 1px solid $colorBase5;
    }
    .bordecito:first-child{
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
      
    }
    .bordecito:last-child{
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
      color: $colorBase2
    }
    .opcionesRoom {
      border-top: 1px solid $colorBase5;
    }
  }
  .elipse {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    padding-right: 15% !important;
  }
  .oculto {
    display: none;
  }
  .subtitle {
    margin-bottom: 16px;
  }
  .labelCheck{
    color: $grayBrownish;
    font-size: $font-size-base;
    font-weight: 300;
  }
  input[type="radio"]:checked ~ label {
    color: $grayShadeDark;
    font-size: $font-size-base;
    font-weight: normal;
  }
  // ESTILOS PARA LA POSICION TOP
  .PC-sidebarTop{
    width: 100%;
    background: #fff;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1), 0 5px 10px 2px rgba(0, 0, 0, 0.2);
    position: fixed;
    top: 55px;
    margin-top: 0;
    z-index: 1;
    height: auto;
    padding: 17px 20px 17px 20px !important;
    text-align: right;
    .contenidoAside{
      margin: 0 auto;
    }
    form{
      padding-right: 40px;
    }
    .form-element{
      text-align: left;
      display: inline-block;
      vertical-align: top;
      width: 33.3333%;
      padding: 0 12px;
      margin-bottom: 10px;
      label{
        margin-bottom: 0;
      }
    }
    .form-element{
      margin-top: 5px;
    }
    .form-element:first-child{
      margin-top: 5px;
    }
    .SidebarTop-info{
      padding: 0;
      margin: 0;
      list-style: none;
      &:after{
        content: '';
        display: table;
        clear: both;
      }
      li{
        float: left;
        vertical-align: middle;
        width: 20%;
        display: block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        span:first-child{
          font-size: $font-size-large;
          color: $colorBase2;
        }
      }
      li{
        padding-right: 20px;
      }
      li:nth-child(3){
        width: 23%;
      }
      li:nth-child(5),
      li:nth-child(6){
        width: 10%;
      }
      li:last-child{
        width: 30%;
      }
    }
    .SidebarTop-toggleButton{
      background: transparent;
      color: $colorBase2;
      padding: 0;
      width: initial;
      height: initial;
      position: absolute;
      right: 15px;
      bottom: -5px;
      &:focus{
        outline: none;
      }
      span{
        font-size: $font-size-biglarge;
      }
      &--open{
        bottom: 5px;
      }
    }
  }
  .seguimiento{
      width: 50% !important;
  }
  @media only screen and (max-width: 736px) {
      .PC-sidebarTop{
        padding: 11px 0 16px 0;
        text-align: left;
        box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
        .form-element{
          text-align: left;
          display: inline-block;
          vertical-align: top;
          width: 33.3333%;
          padding: 0 12px;
          margin-bottom: 0px;
        }
        form{
          padding-right: 0;
          .form-element:nth-child(1),
          .form-element:nth-child(2){
            width: 100%;
          }
          .form-element:nth-child(3),
          .form-element:nth-child(4){
            width: 50%;
          }
          .form-element:nth-child(5){
            width: 100%;
          }
          .form-element:nth-child(6){
            width: 100%;
          }
          .form-element:nth-child(7){
            width: calc( 100% - 40px );
          }
        }
        .SidebarTop-info{
          li:nth-child(2){
            width: 35%;
          }
          li:nth-child(3){
            width: 60%;
          }
          li:nth-child(4),
          li:nth-child(5),
          li:nth-child(6),
          li:nth-child(7){
            display: none;
          }
        }
      }
      .consultar {
        width: 90%;
      }
      .seguimiento{
        width: 100% !important;
      }
    }
</style>